import { Component, Input, OnDestroy } from '@angular/core';
import { IAccount } from '@app/interfaces';
import { IProcessStatus } from '@app/interfaces/process.interface';
import { BehaviorSubject, Subject } from 'rxjs';
import { IOrg } from '../../domain/models/admin';
import { IAdminModalComponent, IAdminModalData } from '../../domain/models/admin-modal';
import { AdminOrganizationsService } from '../../services/admin-orgs.service';

@Component({
	selector: 'app-admin-delete-modal',
	templateUrl: './admin-delete-modal.component.html',
	styleUrls: ['./admin-delete-modal.component.scss'],
})
export class AdminDeleteModalComponent implements IAdminModalComponent, OnDestroy {
	@Input() data: IAdminModalData<IOrg | IAccount>;
	private unsubscribe$: Subject<boolean> = new Subject<boolean>();
	public organizations: IOrg[];
	public showConfirm = false;
	public initProcess = false;
	public processStatus: BehaviorSubject<IProcessStatus> = new BehaviorSubject<IProcessStatus>(IProcessStatus.loading);

	constructor(private readonly adminOrganizationsService: AdminOrganizationsService) {}

	ngOnDestroy(): void {
		this.unsubscribe$.next(true);
		this.unsubscribe$.complete();
	}

	delete(): void {
		this.initProcess = true;
		this.adminOrganizationsService.deleteOrganization((this.data.options as IOrg).org_id).subscribe({
			next: (res) => {
				const status: IProcessStatus = res.success ? IProcessStatus.done : IProcessStatus.failed;
				this.processStatus.next(status);
				setTimeout(() => {
					this.closeEvent({ message: status, listItemId: (this.data.options as IOrg).org_id });
				}, 1500);
			},
		});
	}

	onConfirmed(isConfirmed: boolean): void {
		if (isConfirmed) {
			this.showConfirm = false;
			this.delete();
		} else {
			this.showConfirm = false;
		}
	}

	confirm(): void {
		this.showConfirm = true;
	}

	closeEvent(e?: {}): void {}
}
